export default "__VITE_ASSET__4uhvrCyF__"